module.exports = __webpack_public_path__ + "assets/img/season1-e72c6898.png";